module.exports = __webpack_public_path__ + "img/smartphone_black3.1e54e868.png";